<h1 mat-dialog-title>Delete Job History</h1>
<div mat-dialog-content>
  <div>
    <p>You're going to delete job history</p>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-button [mat-dialog-close]="data" cdkFocusInitial>Confirm</button>
</div>



